import { render, staticRenderFns } from "./LinkCargaRapidaComer.vue?vue&type=template&id=268d00d8"
import script from "./LinkCargaRapidaComer.vue?vue&type=script&lang=js"
export * from "./LinkCargaRapidaComer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports